import _ListItemButton, {
    type ListItemButtonProps,
} from "@mui/material/ListItemButton";
import { Link, type To } from "react-router-dom";


type LinkProps = Omit<
    ListItemButtonProps<typeof Link>,
    "component" | "href" | "ref" | "to"
> & {
    hasLink: true;
    to: To;
};

type ButtonProps = Omit<
    ListItemButtonProps,
    "component" | "href" | "ref"
> & {
    hasLink: false;
    to?: never;
};

type ListItemButtonLinkProps = LinkProps | ButtonProps;

export default function ListItemButtonLink(props: ListItemButtonLinkProps) {
    if (props.hasLink) {
        const { hasLink: _, to, ...linkProps } = props;
        return <_ListItemButton component={Link} to={to} {...linkProps} />;
    }

    const { hasLink: _, ...buttonProps } = props;
    return <_ListItemButton {...buttonProps} />;
}
